import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../../components/admin/Sidebar';

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex h-screen overflow-hidden">
        <AdminSidebar />
        <main className="flex-1 overflow-y-auto bg-gray-100 px-6 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}